module.exports = __webpack_public_path__ + "static/media/reviewicon2.aeffb21b.png";